<template>
  <div>
    <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-group"/> Promotores Activos
        <div class="card-header-actions">
          <!-- <CButton color="info" size="sm" @click="storeModal()">Nuevo Contrato</CButton> -->
        </div>
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable 
        :hover="true"
        :striped="true"
        :border="true"
        :small="true"
        :fixed="true"
        :items="collaborators"
        :fields="fields"
        :items-per-page="10"
        :dark="false"
        pagination
      >
        <template #name="{item}"><td>{{item.name}}</td></template>
        <template #kam_name="{item}"><td>{{item.kam_name ? item.kam_name : '-'}}</td></template>
        <template #route_name="{item}"><td>{{item.route_name ? item.route_name : '-'}}</td></template>
        <template #actions="{item}">
          <td class="table_actions b4">
            <CButton color="info" size="sm" @click="showCollaborator(item)">Ver Visitas</CButton>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
  </CCard>
  </div>
</template>
<script>

import store from '../../store'
import router from '../../router/index'
import ws from '../../services/admin';
import moment from 'moment';

export default {
  name: 'AdminCollaborators',
  components: {
    
  },
  data () {
    return {
      collaborators: [],
      fields: [
          {key: 'name', label: 'Nombre'},
          {key: 'kam_name', label: 'KAM'},
          {key: 'route_name', label: 'Ruta'},
          {key: 'actions', label: 'Acciones', class: 'actions' },
        ]
    }
  },
  mounted: async function() {
    this.loading();

    let is_administrator = localStorage.getItem("is_administrator");

    if(is_administrator == "false"){
      let is_kam = localStorage.getItem("is_kam");

      if(is_kam == "false"){
        window.location.href = "/#/home"; this.loaded(); return;
      }
      else{
        window.location.href = "/#/freelance-visits/available"; this.loaded(); return;
      }
    }

    let response = await ws.getCollaborators(); 

    if(response.type == "success"){
      this.collaborators = response.data;
    }

    this.loaded();
  },
  methods: {
    async showCollaborator (item) {
      this.loading();

      window.location.href = "/#/collaborator/"+item.id+"/visits"; return;

      this.loaded();
    },
    async showContract (item) {
      this.loading();

      window.location.href = "/#/contract/"+item.id+"/branchs"; return;

      this.loaded();
    },
    async showContractVisits (item) {
      this.loading();

      window.location.href = "/#/contract/"+item.id+"/visits"; return;

      this.loaded();
    },
    showToast(type, message){
        store.commit('toast', {color: type, message: message});
    },
    color (value) {
      let $color
      if (value <= 25) {
        $color = 'info'
      } else if (value > 25 && value <= 50) {
        $color = 'success'
      } else if (value > 50 && value <= 75) {
        $color = 'warning'
      } else if (value > 75 && value <= 100) {
        $color = 'danger'
      }
      return $color
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
